import {createSelector} from 'reselect';
import {Store} from '../../../redux/reducers';
import {initialState} from './reducers';

const select = (state: Store) => state.notifications || initialState;

const makeSelectPartnerConfigs = () =>
  createSelector(select, subState => subState.partnerConfigs);

const makeSelectLoading = () =>
  createSelector(select, subState => subState.loading);

const makeSelectError = () =>
  createSelector(select, subState => subState.error);

export default select;
export {
  makeSelectPartnerConfigs,
  makeSelectLoading,
  makeSelectError,
};
